import { useContext, Children, cloneElement, isValidElement } from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

import { HistoryRouteContext } from 'src/routes'
import { VOICE_LIVE_PATH } from 'src/routes/live'

import { Tab } from '@headlessui/react'
import GradientHeader from 'src/components/common/GradientHeader'
import StandardPageWrapper from 'src/components/common/StandardPageWrapper'
import { MainLayout } from 'src/components/layouts/MainLayout'

const ScheduleLayout = ({
  children,
  title,
  activeTab,
  classNameHeader = 'shadow-custom backdrop-blur-sm'
}) => {
  const { redirectTo } = useContext(HistoryRouteContext)
  const selectedIndex = activeTab === 'next_month' ? 1 : 0

  const tabList = [
    {
      title: '今月',
      hasNotification: false,
      index: 0,
      textStyle: 'text-base px-2 py-0.5',
      activeTextStyle: 'background: linear-gradient(to right, #40E7FF 0%, #FF48E2 100%)'
    },
    {
      title: '来月',
      hasNotification: false,
      index: 1,
      textStyle: 'text-base px-2 py-0.5',
      activeTextStyle: 'background: linear-gradient(to right, #40E7FF 0%, #FF48E2 100%)'
    }
  ]

  const childrenWithProps = Children.map(children, (child) => {
    if (isValidElement(child)) {
      return cloneElement(child, { title, activeTab })
    }

    return child
  })

  const handleChangeTab = (tabIndex) => {
    if (tabIndex === selectedIndex) return

    if (tabIndex === 0) {
      redirectTo(VOICE_LIVE_PATH.LiveSchedulePage)
    } else if (tabIndex === 1) {
      redirectTo(VOICE_LIVE_PATH.LiveScheduleNextPage)
    }
  }

  return (
    <MainLayout classNameHeader={classNameHeader} className="overflow-y-hidden" active="mypage">
      <StandardPageWrapper className="fixed top-[42px] h-[calc(100%-42px-74px)]" overflow={true}>
        <Tab.Group selectedIndex={selectedIndex} onChange={handleChangeTab}>
          <GradientHeader
            tabList={tabList}
            title={title}
            backPath="/mypage"
          />
          <Tab.Panels className="relative h-[calc(100%-80px)]">
            <Content>{childrenWithProps}</Content>
          </Tab.Panels>
        </Tab.Group>
      </StandardPageWrapper>
    </MainLayout>
  )
}

ScheduleLayout.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  activeTab: PropTypes.string,
  classNameHeader: PropTypes.string
}

export default ScheduleLayout

const Content = styled.div.attrs({
  className: 'hidden-scroll overflow-y-auto h-full'
})``
